// Header dropdowns (<details data-dropdown>): close when clicking outside, pressing Escape,
// opening another dropdown, or following a link inside one.
(() => {
  const dropdowns = () => document.querySelectorAll('details[data-dropdown][open]');
  const closeAll = (except) => dropdowns().forEach((d) => { if (d !== except) d.removeAttribute('open'); });

  document.addEventListener('click', (e) => {
    const inside = e.target.closest('details[data-dropdown]');
    closeAll(inside);
    if (inside && e.target.closest('a')) inside.removeAttribute('open');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = [...dropdowns()];
    if (!open.length) return;
    closeAll();
    open[0].querySelector('summary')?.focus();
  });
})();
